import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { setLang, type Lang } from '@/i18n';

interface LangOption {
  id: Lang;
  label: string;
  sub: string;
}

const LANGS: LangOption[] = [
  { id: 'ko', label: '한국어', sub: 'KO' },
  { id: 'mn', label: 'Монгол', sub: 'MN' },
  { id: 'en', label: 'English', sub: 'EN' },
];

export function LanguageDropdown() {
  const { i18n } = useTranslation();
  const lang = i18n.language as Lang;
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onDoc(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const cur = LANGS.find((l) => l.id === lang) || LANGS[0];

  return (
    <div className="mp-langdd" ref={ref}>
      <button type="button" className={'mp-langdd__btn' + (open ? ' is-open' : '')} onClick={() => setOpen((o) => !o)}>
        <i className="bi bi-globe2"></i>
        <span className="mp-langdd__cur">{cur.label}</span>
        <i className={'bi mp-langdd__chev ' + (open ? 'bi-chevron-up' : 'bi-chevron-down')}></i>
      </button>
      {open ? (
        <ul className="mp-langdd__menu" role="listbox">
          {LANGS.map((l) => (
            <li key={l.id}>
              <button type="button" role="option" aria-selected={l.id === lang}
                className={'mp-langdd__opt' + (l.id === lang ? ' is-on' : '')}
                onClick={() => { setLang(l.id); setOpen(false); }}>
                <span className="mp-langdd__optsub">{l.sub}</span>
                <span className="mp-langdd__optlabel">{l.label}</span>
                {l.id === lang ? <i className="bi bi-check-lg"></i> : null}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
